<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <!-- <v-icon color="primary" dark v-on="on">home</v-icon> -->
        <span
          class="v-rating"
          v-for="level in [1, 2, 3, 4, 5]"
          :key="level"
          @click="changeValue(level)"
          dark
          v-on="on"
        >
          <starSVG :class="getClassName(level)" />
        </span>
        <!-- <span dark v-on="on" class="ml-2" v-if="showTooltip">{{
          reviews
        }}</span> -->
      </template>
      <span v-if="showTooltip"
        >Rating {{ totalRating }} Reviews {{ reviews }}</span
      >
    </v-tooltip>
  </span>
</template>
<script>
// import _ from "lodash";
import isInteger from "lodash/isInteger";
import starSVG from "@/SVG/star";
export default {
  props: ["rating", "clickable", "reviews", "totalRating", "showTooltip"],
  data() {
    return {
      star_value: this.rating
    };
  },
  watch: {
    rating: {
      handler(newValue) {
        if (newValue) {
          this.star_value = newValue;
        }
      }
    }
  },
  components: {
    starSVG
  },
  watch: {
    rating: function(val) {
      this.star_value = val;
    }
  },
  methods: {
    getClassName(level) {
      let rating = Number(this.star_value);

      if (level < rating + 1) {
        if (Math.floor(rating) >= level) {
          return "active";
        } else {
          if (!isInteger(rating)) {
            return "half-active";
          } else {
            return "active";
          }
        }
      }
      return "";
    },
    changeValue(value) {
      if (!this.clickable) {
        return;
      }
      this.star_value = value;
      this.$emit("input", value);
    }
  }
};
</script>
